import { CfFtpInfo } from 'data/cfFtpInfo/cfFtpInfo.types';
import { WithAuditDetails, AuditDetails, Operation } from 'data/types';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';

export default function getCfFtpInfoDataToSubmit(
  cfFtpInfo: CfFtpInfo,
  originalCfFtpInfo: CfFtpInfo | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): WithAuditDetails<CfFtpInfo> {
  const body: WithAuditDetails<CfFtpInfo> = {
    data: cfFtpInfo,
  };

  let actionType = AuditActionType.CF_FTP_INFO_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.CF_FTP_INFO_EDIT;
    isEdit = true;
  }

  if (isAuditEnabled) {
    const auditDetails = getAuditDetails(
      isAuditEnabled,
      userId,
      userName,
      getAuditFieldInfo(cfFtpInfo, null, isEdit, originalCfFtpInfo),
      cfFtpInfo.id,
      AuditService.CF_FTP_INFO,
      actionType,
    );

    body.auditDetails = auditDetails as AuditDetails;
  }

  return body;
}
